module.exports = __webpack_public_path__ + "img/arrow-circle.7509978d.svg";